// @ts-check
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import { getClients } from '../../../clients/presentation/redux/actions/client-actions';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { Grid, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export default function AdminClientPage() {
  // @ts-ignore
  const { id } = useParams();
  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          <>
            <BackNavigationComponent page="Admin" uri="/" />
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Paper
                  className={classes.paper}
                  elevation={0}
                  onClick={() => history.push('/admin/terminate-orders/' + id)}
                >
                  <div>
                    <b>Terminate Orders</b>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </>
        </Container>
      </React.Fragment>
    </>
  );
}
